import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "invalid", "onUpdate", "placeholderSeparator", "setValuesOfFields", "allowNegative", "includeThousandsSeparator", "placeholder", "showPlaceholder"];
import React from 'react';
import PropTypes from 'prop-types';
import { hasValue } from "../validator";
import { inputTypes } from "../types";

/** A primitive input component. */
import { jsx as ___EmotionJSX } from "@emotion/core";
const BareInput = /*#__PURE__*/React.forwardRef((_ref, ref // eslint-disable-line
) => {
  let {
      invalid,
      placeholder,
      showPlaceholder
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return ___EmotionJSX("input", _extends({
    ref: ref,
    "aria-invalid": invalid,
    placeholder: showPlaceholder ? placeholder : ''
  }, rest));
});
BareInput.validate = hasValue;
BareInput.inputType = inputTypes.text;
BareInput.propTypes = {
  /** Disables the input. */
  disabled: PropTypes.bool,
  /** A unique identifier for the input. */
  id: PropTypes.string,
  /** `true` if the input is in error state and has been touched. */
  invalid: PropTypes.bool,
  /** A name for the component. */
  name: PropTypes.string,
  /** Handler for blur event */
  onBlur: PropTypes.func,
  /** handler for change event */
  onChange: PropTypes.func,
  /** handler for focus event */
  onFocus: PropTypes.func,
  /** Input placeholder. */
  placeholder: PropTypes.string,
  /** If the input is required. Used for validation. */
  required: PropTypes.bool,
  /** The input type. */
  type: PropTypes.string,
  /** The value of the input. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
BareInput.defaultProps = {
  type: 'text',
  value: ''
};
export { BareInput };